import * as campaigns from "./campaigns";
import * as salmons from "./salmons";

export const uthestar = {
    ...campaigns,
    ...salmons
}